import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import IncentiveService from "services/Setup/LoanOrigination/Incentive/incentiveService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  loadingGeneral: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  productList: {},
  refreshList: false,
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
  editIncentiveList: [],
  addIncentiveList: [],
  asuransiJiwaAmount: 0,
  statusRespon: 0,
};

export const postIncentive = createAsyncThunk(
  "Incentive/postIncentive",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await IncentiveService.postIncentive(userInput);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const editIncentive = createAsyncThunk(
  "Incentive/editIncentive",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await IncentiveService.editIncentive(userInput);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deletIncentive = createAsyncThunk(
  "Incentive/deletIncentive",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await IncentiveService.deletIncentive(userInput);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getAddIncentive = createAsyncThunk(
  "ApkLoanKTAFinancial1/getAddIncentive",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await IncentiveService.getAddIncentive(userInput);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  });

export const getEditIncentive = createAsyncThunk(
  "ApkLoanKTAFinancial1/getEditIncentive",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await IncentiveService.getEditIncentive(userInput);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);



export const Proceed = createAsyncThunk(
  "Incentive/Proceed",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await IncentiveService.Proceed(userInput);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);
export const Incentive = createSlice({
  name: "Incentive",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    resetStatusRespon: (state) => {
      state.statusRespon = 0;
    },
  },

  extraReducers: (builder) => {
    builder
      //   post
      .addCase(postIncentive.pending, (state) => {
        state.loading = true;
      })
      .addCase(postIncentive.fulfilled, (state, action) => {
        console.log("actionpostGuarantor", action);
        state.loading = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(postIncentive.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //   edit
      .addCase(editIncentive.pending, (state) => {
        state.loadingGeneral = true;
      })
      .addCase(editIncentive.fulfilled, (state, action) => {
        console.log("actionpostGuarantor", action);
        state.loading = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(editIncentive.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //   delete
      .addCase(deletIncentive.pending, (state) => {
        state.loadingGeneral = true;
      })
      .addCase(deletIncentive.fulfilled, (state, action) => {
        console.log("actionpostGuarantor", action);
        state.loading = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(deletIncentive.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //   get
      .addCase(getAddIncentive.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAddIncentive.fulfilled, (state, action) => { 
        state.loading = false;
        state.addIncentiveList = action?.payload?.data;
      })
      .addCase(getAddIncentive.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // get edit
      .addCase(getEditIncentive.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEditIncentive.fulfilled, (state, action) => { 
        state.loading = false;
        state.editIncentiveList = action?.payload?.data;
      })
      .addCase(getEditIncentive.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Proceed
      .addCase(Proceed.pending, (state) => {
        state.loading = true;
      })
      .addCase(Proceed.fulfilled, (state, action) => { 
        state.loading = false;
        // state.editIncentiveList = action?.payload?.data;
      })
      .addCase(Proceed.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  //    update,
  showNotification,
  hideNotification,
  showLoading,
  resetStatusRespon,
} = Incentive.actions;

export default Incentive.reducer;
